import { createReducer, on } from '@ngrx/store';
import { changeListSeatSelected, loadDropdownListData, loadPermission, showLoading, showLoadingUpdate } from '../actions/common.action';
import { CommonStore } from '@models/store.model';

const initialState: CommonStore = {
    listSeatSelected: [],
    updateLoading: 0,
    loading: 0,
    metadata: {
        cabinDDL: [],
        airPortDDL: [],
        airlineDDL: [],
        countriesDDL: [],
        airCrafts: [],
    },
    auth: {
        session: null,
        permissions: [],
    },
};

export const commonReducer = createReducer<CommonStore>(
    initialState,
    on(loadDropdownListData, (state, { data, key }) => ({
        ...state,
        metadata: {
            ...state.metadata,
            [key]: data,
        },
    })),
    on(changeListSeatSelected, (state, { list }) => {
        return {
            ...state,
            listSeatSelected: list,
        };
    }),
    on(loadPermission, (state, { permissions }) => ({
        ...state,
        auth: {
            ...state.auth,
            permissions,
        },
    })),
    on(showLoadingUpdate, (state, { loading }) => ({
        ...state,
        updateLoading: loading ? state.updateLoading + 1 : state.updateLoading - 1,
    })),
    on(showLoading, (state, { loading }) => {
        const count = loading ? state.loading + 1 : state.loading - 1;

        return {
            ...state,
            loading: count >= 0 ? count : 0,
        };
    }),
);
